import { IDataShowroom } from '@/components/BuilderIO/common/CommonFields';
import SearchBar from '@/components/StoreLocator/SearchBar';
import Button from '@/components/homepage/Button/Button';
import { IS_DEV } from '@/utils/env';

interface IStoreLocatorSearchBar {
  activeView: number;
  hasError: boolean;
  isMobile: boolean;
  errorSearchMessage: string;
  bookAppointment: (showroom: IDataShowroom) => void;
  changeView: (view: number) => void;
  handleInputSearch: (searchInput: string) => void;
}

const VIEWS = {
  storesNearYou: 1,
  allStores: 2,
};

export default function StoreLocatorSearchBar({
  activeView,
  hasError,
  isMobile,
  errorSearchMessage,
  bookAppointment,
  changeView,
  handleInputSearch,
}: IStoreLocatorSearchBar) {
  const handleLocationsClick = () => {
    changeView(activeView === VIEWS.storesNearYou ? VIEWS.allStores : VIEWS.storesNearYou);
    (window as any).dataLayer.push({
      event: activeView === VIEWS.storesNearYou ? 'showroom_locator' : 'view_all_showrooms',
      showroom_action: activeView === VIEWS.storesNearYou ? 'view all locations' : 'locations near you',
      showroom_location: 'undefined',
      showroom_page_section: 'search bar',
    });
  };

  // const handleBookAppointment = () => {
  //   bookAppointment({
  //     modalName: 'Virtual Appointment',
  //     displayName1: 'Virtual Appointment',
  //     displayName2: '',
  //     addresLine1: '',
  //     addressLine2: '',
  //     setsterLocationId: 'Virtual Appointment',
  //     timezoneName: '',
  //     timezoneId: '553',
  //     id: IS_DEV ? '30946' : '30777',
  //     timezoneAbreviation: 'PT',
  //     city: '',
  //     state: '',
  //     zipCode: '',
  //   } as unknown as IDataShowroom);

  //   (window as any).dataLayer.push({
  //     event: activeView === VIEWS.storesNearYou ? 'showroom_locator' : 'view_all_showrooms',
  //     showroom_action: 'book virtual appointment',
  //     showroom_location: 'undefined',
  //     showroom_page_section: 'search bar',
  //   });
  // };
  return (
    <div className="tw-flex tw-flex-col tw-gap-[12px] tw-w-full lg:tw-flex-row lg:tw-gap-[1rem] lg:tw-items-center">
      <SearchBar
        placeholder="Search City, State, or Zip Code"
        className="lg:tw-w-[706px]"
        onClick={handleInputSearch}
        hasError={hasError}
        isMobile={isMobile}
      />

      {/* Error message */}
      {hasError && isMobile && (
        <div className="tw-w-full tw-flex tw-flex-row tw-mt-[-12px] tw-font-book">
          <p className="tw-mb-0 tw-mt-1 tw-text-[11px] tw-text-error">{errorSearchMessage}</p>
        </div>
      )}

      {/* Links in mobile */}
      <div className="tw-flex tw-flex-row tw-gap-[1rem] tw-w-full lg:tw-hidden">
        <a
          className="tw-cursor-pointer tw-underline tw-font-medium tw-leading-normal tw-text-center tw-capitalize focus:tw-outline-none focus-visible:tw-outline-[-webkit-focus-ring-color]"
          onClick={handleLocationsClick}
          role="button"
          tabIndex={0}
          onKeyDown={event => {
            if (event.key === 'Enter') {
              handleLocationsClick();
            }
          }}
        >
          {activeView === VIEWS.storesNearYou ? 'view all locations' : 'locations near you'}
        </a>
        <div className="tw-w-[1px] tw-h-[17px] tw-bg-[#D9D9D9]" />
        <Button
          className="tw-cursor-pointer tw-underline tw-font-medium tw-leading-normal tw-text-center tw-capitalize focus:tw-outline-none focus-visible:tw-outline-[-webkit-focus-ring-color] tw-text-sm tw-p-0"
          onClick={() => {
            bookAppointment({
              modalName: 'Virtual Appointment',
              displayName1: 'Virtual Appointment',
              displayName2: '',
              addresLine1: '',
              addressLine2: '',
              setsterLocationId: 'Virtual Appointment',
              timezoneName: '',
              timezoneId: '553',
              id: IS_DEV ? '30946' : '30777',
              timezoneAbreviation: 'PT',
              city: '',
              state: '',
              zipCode: '',
            } as unknown as IDataShowroom);
            (window as any).dataLayer.push({
              event: activeView === VIEWS.storesNearYou ? 'showroom_locator' : 'view_all_showrooms',
              showroom_action: 'book virtual appointment',
              showroom_location: 'undefined',
              showroom_page_section: 'search bar',
            });
          }}
          type="link"
          label="Book Virtual Appointment"
        />
      </div>

      {/* Links in desktop */}
      <div className="tw-hidden lg:tw-flex lg:tw-gap-[1rem]">
        <Button
          label={activeView === VIEWS.storesNearYou ? 'view all locations' : 'locations near you'}
          className="tw-bg-[#ECE2DF] tw-text-black tw-min-w-[202px] tw-capitalize tw-py-0 tw-h-[44px] hover:tw-bg-[#D1C1BC] hover:tw-text-color-[#2C2C2C]"
          onClick={() => {
            changeView(activeView === VIEWS.storesNearYou ? VIEWS.allStores : VIEWS.storesNearYou);

            (window as any).dataLayer.push({
              event: activeView === VIEWS.storesNearYou ? 'showroom_locator' : 'view_all_showrooms',
              showroom_action: activeView === VIEWS.storesNearYou ? 'view all locations' : 'locations near you',
              showroom_location: 'undefined',
              showroom_page_section: 'search bar',
            });
          }}
        />
        <Button
          label="Book Virtual Appointment"
          onClick={() => {
            bookAppointment({
              modalName: 'Virtual Appointment',
              displayName1: 'Virtual Appointment',
              displayName2: '',
              addresLine1: '',
              addressLine2: '',
              setsterLocationId: 'Virtual Appointment',
              timezoneName: '',
              timezoneId: '553',
              id: IS_DEV ? '30946' : '30777',
              timezoneAbreviation: 'PT',
              city: '',
              state: '',
              zipCode: '',
            } as unknown as IDataShowroom);
            (window as any).dataLayer.push({
              event: activeView === VIEWS.storesNearYou ? 'showroom_locator' : 'view_all_showrooms',
              showroom_action: 'book virtual appointment',
              showroom_location: 'undefined',
              showroom_page_section: 'search bar',
            });
          }}
          className="tw-bg-transparent tw-border tw-border-solid tw-border-[#D9D9D9] tw-text-black tw-min-w-[202px] tw-py-0 tw-h-[44px] hover:tw-bg-[#2C2C2C] hover:tw-border-transparent"
        />
      </div>
    </div>
  );
}
